import React from "react";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "../utils/i18n";

const LANGUAGES = [
  { code: "sv", flag: "🇸🇪", label: "Svenska" },
  { code: "en", flag: "🇬🇧", label: "English" },
];

export default function LanguageSwitcher({ textColor = "#0B0F13" }) {
  const { lang, setLang } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <>
      <Box
        role="button"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.4,
          cursor: "pointer",
          userSelect: "none",
          px: 0.75,
          py: 0.5,
          borderRadius: 1,
          "&:hover": { bgcolor: "rgba(0,0,0,0.05)" },
        }}
      >
        <Typography sx={{ fontSize: "1.2rem", lineHeight: 1 }}>
          {current.flag}
        </Typography>
        <KeyboardArrowDownIcon
          sx={{
            fontSize: 16,
            color: textColor,
            opacity: 0.6,
            transition: "transform 180ms ease",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          sx: {
            mt: 0.5,
            minWidth: 140,
            borderRadius: 2,
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            border: "1px solid #E3E6EB",
            py: 0.5,
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {LANGUAGES.map((l) => (
          <MenuItem
            key={l.code}
            selected={l.code === lang}
            onClick={() => { setLang(l.code); setAnchorEl(null); }}
            sx={{
              gap: 1.25,
              py: 0.9,
              px: 1.75,
              borderRadius: 1,
              mx: 0.5,
              fontSize: "0.875rem",
              fontWeight: l.code === lang ? 700 : 400,
              color: l.code === lang ? "#FF6A00" : "#1D2129",
              "&.Mui-selected": { bgcolor: "rgba(255,106,0,0.06)" },
              "&:hover": { bgcolor: "rgba(0,0,0,0.04)" },
            }}
          >
            <Typography sx={{ fontSize: "1.1rem", lineHeight: 1 }}>
              {l.flag}
            </Typography>
            {l.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
